import * as PIXI from "pixi.js";
import { globalData } from "./globalData";
import { config } from "./appConfig";
// import { Spine } from "pixi-spine";
import { tweenFadeOut, tweenPopScale, tweenSirenAlpha } from "./utility";

export class bulbMeter {

    bulbMeterContainer = null;

    fuelHolder = null;
    digitalMeter = null;

    multiplierContainer = null;

    fuel = []
    num = []

    totalFuel = 6

    blinker1 = null
    blinker0 = null

    constructor(x, y) {

        this.bulbMeterContainer = new PIXI.Container();
        this.multiplierContainer = new PIXI.Container();

        this.fuelHolder = new PIXI.Sprite(PIXI.Assets.get('fuelBase'));
        this.fuelHolder.anchor.set(0.5);
        this.fuelHolder.scale.set(1);
        this.fuelHolder.position.set(x, y);
        this.bulbMeterContainer.addChild(this.fuelHolder);

        this.digitalMeter = new PIXI.Sprite(PIXI.Assets.get('digimeter'));
        this.digitalMeter.anchor.set(0.5);
        this.digitalMeter.scale.set(1);
        this.digitalMeter.position.set(x - this.fuelHolder.width + 80, y - 75);
        // this.fuelHolder.addChild(this.digitalMeter);

        this.bulbMeterContainer.addChild(this.multiplierContainer);
        // this.fillFuel(this.totalFuel)
    }


    fillFuel(level = 6) {
        this.totalFuel = level;
        if (this.fuel.length) {
            this.fuel.forEach(element => {
                this.fuelHolder.removeChild(element);
                element = null;
            });
            this.fuel = [];

            this.num.forEach(element => {
                this.digitalMeter.removeChild(element);
                element = null;
            });
            this.num = [];
        }

        for (let fuelLevel = 0; fuelLevel <= level; fuelLevel++) {
            this.fuel[fuelLevel] = new PIXI.Sprite(PIXI.Assets.get('fuel' + (fuelLevel)));
            this.fuel[fuelLevel].anchor.set(0.5);
            this.fuel[fuelLevel].scale.set(1);
            this.fuelHolder.addChild(this.fuel[fuelLevel]);

        }


        for (let fuelLevel = 0; fuelLevel <= level; fuelLevel++) {
            this.num[fuelLevel] = new PIXI.Sprite(PIXI.Assets.get('num' + (fuelLevel)));
            this.num[fuelLevel].anchor.set(0.5);
            this.num[fuelLevel].scale.set(1);
            this.digitalMeter.addChild(this.num[fuelLevel]);
            this.bulbMeterContainer.addChild(this.digitalMeter);

            if (fuelLevel < level) {
                this.num[fuelLevel].visible = false;
            }

        }
        this.createSirens();
    }

    emptyFuel() {
        while (this.fuelHolder.children.length > 0) {
            const child = this.fuelHolder.getChildAt(0);
            this.fuelHolder.removeChild(child);

        }
        this.fuel = [];
    }


    createSirens() {
        this.blinker1 = new PIXI.Sprite(PIXI.Assets.get('fuel1blinker'));
        this.blinker1.anchor.set(0.5);
        this.blinker1.scale.set(1);
        this.blinker1.position.set(0, 0);
        this.fuel[1].addChild(this.blinker1);

        this.blinker0 = new PIXI.Sprite(PIXI.Assets.get('fuel0blinker'));
        this.blinker0.anchor.set(0.5);
        this.blinker0.scale.set(1);
        this.blinker0.position.set(0, 0);
        this.fuel[0].addChild(this.blinker0);

        tweenSirenAlpha(this.blinker0, 1)
        tweenSirenAlpha(this.blinker1, 1)

        this.numBlinker1 = new PIXI.Sprite(PIXI.Assets.get('num1blinker'));
        this.numBlinker1.anchor.set(0.5);
        this.numBlinker1.scale.set(1);
        this.numBlinker1.position.set(0, 0);
        this.num[1].addChild(this.numBlinker1);

        this.numBlinker2 = new PIXI.Sprite(PIXI.Assets.get('num0blinker'));
        this.numBlinker2.anchor.set(0.5);
        this.numBlinker2.scale.set(1);
        this.numBlinker2.position.set(0, 0);
        this.num[0].addChild(this.numBlinker2);

        tweenSirenAlpha(this.numBlinker1, 1)
        tweenSirenAlpha(this.numBlinker2, 1)

    }


    useFuel() {
        tweenPopScale(this.fuelHolder, 1)
        tweenFadeOut(this.fuel[this.totalFuel])

        this.totalFuel--;

        for (let fuelLevel = 0; fuelLevel < this.num.length; fuelLevel++) {
            this.num[fuelLevel].visible = false;
        }
        this.num[this.totalFuel].visible = true;
    }

}